<template>
    <LayoutPage>
        <template v-slot:banner>
            <BannerSmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :title="'Workshopy'"
                :description="'Prihláste sa na niektorý z pripravovaných workshopov, alebo využite možnosť vytvorenia workshopu na mieru.'"
            />
        </template>
        <template v-slot:content>
            <div class="box box--space-vertical">
                <div class="mm-section">
                    <div class="mm-section-content">
                        <div class="container-fluid w-100">

                            <div class="box box--space-vertical">
                                <router-link :to="localeRoute('workshops')"
                                    class="mm-link mm-link--icon-left-space-s">
                                    <i class="icon icon-arrow-left"></i>späť na zoznam workshopov
                                </router-link>
                            </div>

                            <div class="row">
                                <div class="col-sm-6 col-md-5 col-lg-5 box box--space-bottom">
                                    <img src="/css/images/homepage/workshop_request.PNG" alt="" style="width: 100%">
                                </div>
                                <div class="col-sm-6 col-md-7 col-lg-6">
                                    <div class="box ">
                                        <span class="headline headline--fourth">
                                            Nevyhovuje Vám žiadny z aktuálne pripravovaných workshopov?
                                        </span>
                                        <p class="text--bigger-paragraph">
                                            Napíšte nám, za akým účelom sa chystáte mapový portál používať a my Vám pripravíme workshop na mieru.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row justify-content-md-center box box--grey box--space-inside box--space-vertical box--center">
                                <div
                                    v-if="submitStatus !== 'SUCCESS'"
                                    class="col-lg-8 col-md-12 box box--spaces">
                                    <h3 class="headline headline--fifth">
                                        Napíšte nám o aký workshop máte záujem.
                                    </h3>
                                    <form @submit.prevent="onSubmit">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <Field
                                                    :trimModel="true"
                                                    :fieldModel="$v.name"
                                                    :field="nameField">
                                                </Field>
                                            </div>
                                            <div class="col-md-6">
                                                <Field
                                                    :trimModel="true"
                                                    :fieldModel="$v.surname"
                                                    :field="surnameField">
                                                </Field>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <Field
                                                    :trimModel="true"
                                                    :fieldModel="$v.email"
                                                    :field="emailField">
                                                </Field>
                                            </div>
                                            <div class="col-md-6">
                                                <Field
                                                    :trimModel="true"
                                                    :fieldModel="$v.telephone"
                                                    :field="telephoneField">
                                                </Field>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <TextAreaField
                                                    className="materialize-textarea--xl"
                                                    :fieldModel="$v.comment"
                                                    :field="commentField">
                                                </TextAreaField>
                                            </div>
                                        </div>
                                        <p v-if="submitStatus === 'ERROR'"
                                            class="text text--error">
                                            Doslo k chybe. Zkontrolujte prosim formular a odeslete ho znovu
                                        </p>

                                        <button
                                            v-if="submitStatus === 'REQUEST'"
                                            disabled
                                            class="button button--wider-border transparent--button button--l button--uppercase">
                                            Odesilani
                                        </button>
                                        <button
                                            v-else
                                            class="button button--wider-border normal--button button--xl button--uppercase">
                                            odoslať
                                        </button>
                                    </form>
                                </div>
                                <div v-if="submitStatus === 'SUCCESS'"
                                    class="col box--center">
                                    <div>
                                        <div class="box box--spaces">
                                            <span class="icon icon-eye icon-4x"></span>
                                        </div>
                                        <h3 class="headline headline--third headline--uppercase">
                                            ďakujeme
                                        </h3>
                                    </div>
                                    <br>
                                    <h3 class="headline headline--fifth">
                                        Vaša správa bola úspešne odoslaná!
                                    </h3>
                                    <h3 class="headline headline--fifth">
                                        Budeme Vás kontaktovať.
                                    </h3>
                                </div>


                            </div>


                        </div>
                    </div>
                </div>
            </div>


        </template>
    </LayoutPage>
</template>

<script>
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta';
import Field from '@/components/ui/Field';
import TextAreaField from '@/components/ui/TextAreaField';
import { getFields, validations } from './forms';
import LayoutPage from '@/components/layouts/Page';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';
import { requestWorkshop } from '@/services/MapsfyApi';

export default {
    components: {
        BannerSmallerWithSearchAndButton,
        LayoutPage,
        Field,
        TextAreaField
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
    },
    data() {
        const $t = this.$t.bind(this);
        return {
            data: null,
            submitStatus: null,
            name: "",
            surname: "",
            telephone: "",
            email: "",
            comment: "",
            emailId: this.formId + '-inputEmail',
            ...getFields($t)
        };
    },
    validations: {
        ...validations
    },
    methods: {
        onSubmit() {
            this.$v.$touch();
            this.submitStatus = null;
            this.submitStatus = "REQUEST";

            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR';
            }

            if (!this.$v.$invalid) {
                 const prop = {
                    name: this.name,
                    surname: this.surname,
                    email: this.email,
                    phone: this.telephone,
                    message: this.comment
                };

                requestWorkshop(prop)
                    .then(() => {
                        this.submitStatus = 'SUCCESS';
                    })
                    .fail(e => {
                        console.log('ERROR: ', e);
                        this.submitStatus = 'ERROR';
                    });
            }
        }
    },
    computed: {
        pageId() {
            return this.$route.params.id;
        },
        image_preview() {
            if (this.data && this.data.attachments) {
                var image = this.data.attachments.find(item => item.type === "preview-image");
                if (image) {
                    return `https://mm_cms.emis-online.sk/cms/web_cms_apigateway/api/Pages/pages/attachment/${image.attachmentKey}`;
                }
            }
            return null;
        }

    }
}
</script>

